// pitches
const C1 = 0 + 12 * 1, c1 = 1 + 12 * 1, D1 = 2 + 12 * 1, d1 = 3 + 12 * 1, E1 = 4 + 12 * 1, F1 = 5 + 12 * 1, f1 = 6 + 12 * 1, G1 = 7 + 12 * 1, g1 = 8 + 12 * 1, A1 = 9 + 12 * 1, a1 = 10 + 12 * 1, B1 = 11 + 12 * 1;
const C2 = 0 + 12 * 2, c2 = 1 + 12 * 2, D2 = 2 + 12 * 2, d2 = 3 + 12 * 2, E2 = 4 + 12 * 2, F2 = 5 + 12 * 2, f2 = 6 + 12 * 2, G2 = 7 + 12 * 2, g2 = 8 + 12 * 2, A2 = 9 + 12 * 2, a2 = 10 + 12 * 2, B2 = 11 + 12 * 2;
const C3 = 0 + 12 * 3, c3 = 1 + 12 * 3, D3 = 2 + 12 * 3, d3 = 3 + 12 * 3, E3 = 4 + 12 * 3, F3 = 5 + 12 * 3, f3 = 6 + 12 * 3, G3 = 7 + 12 * 3, g3 = 8 + 12 * 3, A3 = 9 + 12 * 3, a3 = 10 + 12 * 3, B3 = 11 + 12 * 3;
const C4 = 0 + 12 * 4, c4 = 1 + 12 * 4, D4 = 2 + 12 * 4, d4 = 3 + 12 * 4, E4 = 4 + 12 * 4, F4 = 5 + 12 * 4, f4 = 6 + 12 * 4, G4 = 7 + 12 * 4, g4 = 8 + 12 * 4, A4 = 9 + 12 * 4, a4 = 10 + 12 * 4, B4 = 11 + 12 * 4;
const C5 = 0 + 12 * 5, c5 = 1 + 12 * 5, D5 = 2 + 12 * 5, d5 = 3 + 12 * 5, E5 = 4 + 12 * 5, F5 = 5 + 12 * 5, f5 = 6 + 12 * 5, G5 = 7 + 12 * 5, g5 = 8 + 12 * 5, A5 = 9 + 12 * 5, a5 = 10 + 12 * 5, B5 = 11 + 12 * 5;
const C6 = 0 + 12 * 6, c6 = 1 + 12 * 6, D6 = 2 + 12 * 6, d6 = 3 + 12 * 6, E6 = 4 + 12 * 6, F6 = 5 + 12 * 6, f6 = 6 + 12 * 6, G6 = 7 + 12 * 6, g6 = 8 + 12 * 6, A6 = 9 + 12 * 6, a6 = 10 + 12 * 6, B6 = 11 + 12 * 6;


// notes
export enum notes {
    A = 1,
    Asharp = 2,
    B = 3,
    C = 4,
    Csharp = 5,
    D = 6,
    Dsharp = 7,
    E = 8,
    F = 9,
    Fsharp = 10,
    G = 11,
    Gsharp = 12
}

export const noteValues: { [name: string]: Array<number> } = {
    'A': [A1, A2, A3, A4, A5, A6],
    'Asharp': [a1, a2, a3, a4, a5, a6],
    'B': [B1, B2, B3, B4, B5, B6],
    'C': [C1, C2, C3, C4, C5, C6],
    'Csharp': [c1, c2, c3, c4, c5, c6],
    'D': [D1, D2, D3, D4, D5, D6],
    'Dsharp': [d1, d2, d3, d4, d5, d6],
    'E': [E1, E2, E3, E4, E5, E6],
    'F': [F1, F2, F3, F4, F5, F6],
    'Fsharp': [f1, f2, f3, f4, f5, f6],
    'G': [G1, G2, G3, G4, G5, G6],
    'Gsharp': [g1, g2, g3, g4, g5, g6]
};


// strings
export enum strings {
    E = 1,
    A = 2,
    D = 3,
    G = 4
}

export const noteDuration = {
    whole: 1,
    half: 1 / 2,
    quarter: 1 / 4,
    eighth: 1 / 8,
    sixteenth: 1 / 16
};

export const fretBoard: Array<Array<number>> = [];
fretBoard[strings.G] = [G2, g2, A3, a3, B3, C3, c3, D3, d3, E3, F3, f3, G3];
fretBoard[strings.D] = [D2, d2, E2, F2, f2, G2, g2, A3, a3, B3, C3, c3, D3];
fretBoard[strings.A] = [A1, a1, B1, C2, c2, D2, d2, E2, F2, f2, G2, g2, A2];
fretBoard[strings.E] = [E1, F1, f1, G1, g1, A1, a1, B1, C2, c2, D2, d2, E2];


export interface Note {
    pitch?: number;
    duration: number;
}